// client/src/customerFavorite/customerFavorite.tsx
import React, { FC } from 'react';
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    ListProps,
    useListContext,
    useGetOne,
} from 'react-admin';
import IconButton from '@mui/material/IconButton';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

// Back‐button toolbar
const CustomerFavoriteActions: FC = () => {
    const navigate = useNavigate();
    return (
        <TopToolbar>
            <IconButton onClick={() => navigate('/customers')}>
                <ArrowBack />
            </IconButton>
        </TopToolbar>
    );
};

// Dynamic title displaying the customer's mobile number
const CustomerFavoriteTitle: FC = () => {
    const { filterValues } = useListContext();
    const customerId = filterValues.customer_id;
    const { data, isLoading } = useGetOne('customers', { id: customerId });
    return (
        <span>
            {isLoading
                ? 'Favorites'
                : `${data?.phone_mobile ?? 'Customer'} Favorites`}
        </span>
    );
};

// List of products favorited by this customer
const CustomerFavoriteList: FC<ListProps> = props => (
    <List
        {...props}
        title={<CustomerFavoriteTitle />}
        actions={<CustomerFavoriteActions />}
        bulkActionButtons={false}
        sort={{ field: 'description', order: 'ASC' }}
    >
        <Datagrid rowClick="show">
            <TextField source="category" label="Category" />
            <TextField source="subcategory" label="Sub Category" />
            <TextField source="description" label="Description" />
            <TextField source="grade" label="Grade" />
        </Datagrid>
    </List>
);

export default CustomerFavoriteList;
